import { render, staticRenderFns } from "./OntUpgradeFw.vue?vue&type=template&id=6cfc7048&"
import script from "./OntUpgradeFw.vue?vue&type=script&lang=js&"
export * from "./OntUpgradeFw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports